<!-- 
  Este arquivo é um exemplo de index de algum model, considerando paginação, filtros e ordenação server-side
  Ao desenvolver qualquer tela de um model novo, o index deve ser o primeiro arquivo a ser construido, pois é ele quem chama todas as ações possíveis dos registros
  Dessa forma, ele contém os links para o new, edit, delete e qualquer outra ação que possa ser necessária.
-->
<template>
  <!-- 
    O baseIndex é um componente padrão utilizado em todas as telas do tipo index para facilitar o desenvolvimento de novos index 
    Porém, é importante notar que tudo é enviado para esse componente e ele é quem renderiza a tabela com os dados.
  -->
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    itemKey="key"
  >
    <!-- 
      Aqui ficam todas as actions que podem ser executadas a partir do index.
      Cada uma delas tem um condicional para verificar se o usuário tem permissão de acesso à essa funcionalidade.

      Os slots são espaços que irão carregar outros componentes mas serão renderizados de acordo com o BaseIndex.
      Já existem slots padrão para o new, edit e delete, pois são os que ocorrem com mais frequencia.
      O único slot que não é específico por item da tablea é o new, que adiciona o botão azul no canto superior direito da tela.
      
      Também existem lotes genéricos, para adicionar ações diferentes das 2 listas em cada item. Para usa-los basta trocar o slot para action1, action2, ... action10
    -->
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />   
    </template>

    <template slot="action1" slot-scope="{ item }" v-if="loggedUser && loggedUser.isAltavenda">
      <ImportClient
        :entry="item"
        @entry-destroyed="entryDeleted"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>


  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag' //importação do gql para execução de queries do GraphQL
import BaseIndex from "@shared_components/base_index.vue"; //importação do baseIndex
import New from "./new.vue"; //importação do componente que vai representar o new do model
import Edit from "./edit.vue"; //importação do componente que vai representar o edit do model
import ImportClient from "./import_clients.vue";
// import BasePopup from '@shared_components/base_popup.vue';


export default {
  data() {
    return {
      formErrors: [],
      indexItems: [], //representa a lista de itens que serão exibidos no index
      loading: true, //indica se a tabela está carregando
      pageLoading: false, //indica se a tela está em carregando
      totalItems: 0, //indica o numero total de itens, utilizado para a paginação
      loggedUser: null,
      // tableHeaders: [],
      maskFields: [ //indica os campos que serão aplicados mascaras, como por exemplo data, valor númerico, valor monetário,... o campo field tem que ser igual o campo value da tableHeaders      
        {field: "isActive", mask: "nice_boolean"},
        { field: 'lastSignInAt', mask: 'datetime' },
        { field: 'createdAt', mask: 'datetime'},
        // { field: 'totalPaidAmount', mask: 'currency' },
        // { field: 'unpaidAmount', mask: 'currency'},
      ],
      infoHeaders: [ //indica as colunas que terão o i de informação. o campo field tem que ser igual o campo value da tableHeaders
        // { field: 'totalPrice', info: 'Valor da conta a pagar (capital)' },
        // { field: 'totalPaidAmount', info: 'Valor já pago da conta incluindo juros, multas e descontos' },
        // { field: 'unpaidAmount', info: 'Valor restante a ser pago (capital)' },
      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Usuário"
    },
    modelNamePlural: {
      type: String,
      default: "Usuários"
    },
    cancelIcon: {
      type: String,
      default: "mdi-calendar-check",
    },
    cancelColor: {
      type: String,
      default: "success"
    },
  },
  components: { //todos os componentes adicionais que forem importados precisam ser registrados aqui
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    // BasePopup: BasePopup,
    ImportClient: ImportClient,
  },
  async created() { //função executada quando o esse componente é criado
    // this.loadServerEntries();
    await this.getCurrentUser(user => {
      this.loggedUser = user;
    });
  },
  mounted() { //função executada quando o esse componente é montado

  },
  computed: {
    tableHeaders: function() {
      return [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Usuário", align: "left", sortable: true, value: "person.name"},
        { text: "E-mail (login)", align: "left", sortable: true, value: "email" },
        { text: "Perfil", align: "left", sortable: true, value: "role.text", filter_value: "role.name" },
        ... this.$can('create', 'UserForAdmin') ? [{ text: "Conta", align: "left", sortable: true, value: "account.name" }] : [], 
        ... this.$can('create', 'UserForAdmin') ? [{ text: "Criação", align: "left", sortable: true, value: "createdAt" }] : [],
        { text: "Último login", align: "left", sortable: true, value: "lastSignInAt" },
        { text: "Ativo", align: "left", sortable: false, value: "isActive" },
        { text: "Ações", align: "left", sortable: false, value: "action" } 
      ]
    }
  }, 
  methods: {
    cancelAction: function () {
      this.$refs.baseDelete.closeDialog();
      // this.$emit('entry-canceled');
    },
    loadUser: function (item) {
      // this.loading = true;
      // this.$apollo
      //   .mutate({
      //     mutation: CANCEL_MDFE_MUTATION,
      //     variables: {
      //       id: item.id,
      //       xjust: this.xjust,
      //     }
      //   })
      //   .then(response => {
      //     var errors = response.data.cancelMdfe.errors
      //     if (errors.length) {
      //       this.formErrors = errors
      //     } else {
      //       // this.$emit("entry-destroyed");
      //       this.$refs.baseDelete.closeDialog();
      //     }
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => {
      //     (this.loading = false);
      //     this.loadServerEntries();
      //   });
    },
    applyFilters: function(filtersList) { //função executada quando o usuário adicionar, editar ou remover um filtro 
      this.filters = filtersList;
      this.options.page = 1; //sempre carrega a primeira página da paginação quando há alterações de filtros
      this.loadServerEntries();
    },
    loadServerEntries: function() { //ao carregar o index, essa função vai executar a query e buscar os dados do servidor
      this.loading = true; //coloca a tabela em loading antes de chamar a query no servidor
      this.$apollo
        .query({
          query: LOAD_ALL_USERS, //esse exemplo mostra uma query que traz todos os cash_outflows, levando em consideração paginação, ordenação e filtros
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("response", response);
          this.indexItems = response.data.accountContext.usersIndex.userViewIndices; //seta os itens retornados do servidor para o array de itens que será exibido na tabela

          this.totalItems = response.data.accountContext.usersIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.usersIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.usersIndex.serverFields; // seta os campos que podem ser filtrados
          // console.log("All indexItems", this.indexItems, this.totalItems); // exibe os itens e o número total de itens no console se for preciso
        })
        .catch(response => console.log(response)) //se der uma exceção ao executar a query, vai jogar isso pro console do navegador
        .finally(() => (this.loading = false)); //ao finalizar a conexão, tira a tabela do loading
    },
    entryUpdated: function(){ //função chamada toda vez que um registro for atualizado
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){ //função chamada toda vez que um registro for criado
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){ //função chamada toda vez que um registro for deletado
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    // exemplo de função que pode ser utilizada para a adição de classes por item que será exibido na tabela
    // nesse exemplo, o item é passado como parametro, assim podem ser acessados atributos do item, como nesse caso o unpaidAmount.
    // se o unpaidAmount for maior que 0 vai adicionar a classe pending_item, que seta a cor do texto do item para vermelho.
    // caso isso seja necessário, descomentar aas linhas internas da função
    itemClasses: function(item) { 
      // if (item.unpaidAmount > 0) {
      //   return "pending_item";
      // }
    },
    optionsChange: function(opts) { //função que é executada toda vez que o usuário alterar alguma opção da paginação, dai recarrega a tabela
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

//exemplo da query do GraphQL que é chamada ao executar o loadServerEntries
const LOAD_ALL_USERS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      usersIndex(input: $input) {
        count
        typeOperators
        serverFields
        userViewIndices {
          id
          code
          email
          isActive
          lastSignInAt
          createdAt
          person {
            id
            name
          }
          role {
            id
            name
            text
          }
          account {
            id
            name
          }
          key
        }
      }
    }
  }
`;

</script>

<style scoped>
  /* exemplo de regra css aplicada a cada item da tabela, por ser scoped, somente esse componente tem acesso a essa regra css */
  /* ::v-deep .pending_item {
    color: red;
  } */
</style>
